import React, { useState } from 'react';
import {
  Container,
  TextField,
  Table,
  TableBody,
  TableCell,
  Box,
  Typography,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
  InputAdornment,
  Stack,
  FormControl,
  InputLabel,
  Modal,
  MenuItem,
  Select,
  IconButton,
  useTheme,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import {
  Search as SearchIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import {
  
  Close as CloseIcon,
} from '@mui/icons-material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SalesExecutivePerformance = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOptions = [5, 10, 20, 30];
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const[showUserGuideModal,setShowUserGuideModal]=useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  // Static data for sales executive performance
  const staticSalesExecutivePerformanceData = [
    { salesExecutiveId: 1, employeeCode: 'EMP001', salesExecutiveName: 'John Doe', designation: 'Senior Sales Executive', client: 'Client A', candidate: '120', date: '2023-10-01' },
    { salesExecutiveId: 2, employeeCode: 'EMP002', salesExecutiveName: 'Jane Smith', designation: 'Sales Executive', client: 'Client B', candidate: '95', date: '2023-10-02' },
    { salesExecutiveId: 3, employeeCode: 'EMP003', salesExecutiveName: 'Alice Johnson', designation: 'Senior Sales Executive', client: 'Client C', candidate: '130', date: '2023-10-03' },
    { salesExecutiveId: 4, employeeCode: 'EMP004', salesExecutiveName: 'Bob Brown', designation: 'Sales Executive', client: 'Client D', candidate: '60', date: '2023-10-04' },
    { salesExecutiveId: 5, employeeCode: 'EMP005', salesExecutiveName: 'Charlie Davis', designation: 'Senior Sales Executive', client: 'Client E', candidate: '110', date: '2023-10-05' },
    { salesExecutiveId: 6, employeeCode: 'EMP006', salesExecutiveName: 'Eve Wilson', designation: 'Sales Executive', client: 'Client F', candidate: '90', date: '2023-10-06' },
  ];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const filteredData = staticSalesExecutivePerformanceData.filter((salesExecutive) => {
    const matchesSearchTerm =
      salesExecutive.salesExecutiveName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      salesExecutive.employeeCode.toLowerCase().includes(searchTerm.toLowerCase()) ||
      salesExecutive.designation.toLowerCase().includes(searchTerm.toLowerCase()) ||
      salesExecutive.client.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesFromDate = fromDate ? new Date(salesExecutive.date) >= new Date(fromDate) : true;
    const matchesToDate = toDate ? new Date(salesExecutive.date) <= new Date(toDate) : true;

    return matchesSearchTerm && matchesFromDate && matchesToDate;
  });

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container maxWidth={false} sx={{ width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent:'space-between',
          mb: 1,
          p: 2,
          boxShadow: 'none',
          maxWidth: '100%',
          boxSizing: 'border-box',
        }}
      >
        <Box sx={{display :'flex',justifyContent:'center',alignItems:'center',gap:2}}>
       <TextField
                                  variant="outlined"
                                  placeholder="Search..."
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <SearchIcon
                                          sx={{
                                            color: theme.palette.primary.main,
                                            marginLeft: 1.5,
                                            fontSize: 24,
                                          }}
                                        />
                                      </InputAdornment>
                                    ),
                                    endAdornment: searchTerm && (
                                      <InputAdornment position="end">
                                        <IconButton
                                          size="small"
                                          onClick={() => setSearchTerm('')}
                                          sx={{
                                            color: "grey",
                                            marginRight: 1,
                                          }}
                                        >
                                          <CloseIcon fontSize="small" />
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                    sx: {
                                      borderRadius: '30px',
                                      backgroundColor: theme.palette.mode === 'dark'
                                        ? 'rgba(255, 255, 255, 0.15)'
                                        : 'rgba(255, 255, 255, 1)',
                                      boxShadow: theme.palette.mode === 'dark'
                                        ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                        : '0 2px 8px rgba(0, 0, 0, 0.1)',
                                      '& .MuiOutlinedInput-notchedOutline': {
                                        border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                                      },
                                      '&:hover': {
                                        backgroundColor: theme.palette.mode === 'dark'
                                          ? 'rgba(255, 255, 255, 0.2)'
                                          : 'rgba(240, 240, 240, 1)',
                                        boxShadow: theme.palette.mode === 'dark'
                                          ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                          : '0 2px 12px rgba(0, 0, 0, 0.15)',
                                      },
                                      '&.Mui-focused': {
                                        backgroundColor: theme.palette.mode === 'dark'
                                          ? 'rgba(255, 255, 255, 0.25)'
                                          : 'rgba(255, 255, 255, 1)',
                                        boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                        '& .MuiOutlinedInput-notchedOutline': {
                                          border: `2px solid ${theme.palette.primary.main}`,
                                        },
                                      },
                                      paddingLeft: 1.5,
                                      height: '50px',
                                      transition: 'all 0.3s ease',
                                    },
                                  }}
                                  sx={{
                                    width: 350,
                                    maxWidth: '100%',
                                    '& .MuiInputBase-input': {
                                      padding: '10px 14px',
                                      color: theme.palette.text.primary,
                                      fontWeight: 500,
                                    },
                                  }}
                                />
          <TextField
            label="From Date"
            type="date"
            variant="outlined"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
                mb: 3,
                mt:'20px',
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
          />
          <TextField
            label="To Date"
            type="date"
            variant="outlined"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
                mb: 3,
                mt:"20px",
                '& .MuiInputLabel-root': {
                  color: theme.palette.text.primary,
                },
                '& .MuiInputLabel-root.Mui-focused': {
                  color: theme.palette.primary.main,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
                '& .MuiInputBase-input[type="date"]::-webkit-calendar-picker-indicator': {
                  filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
                },
              }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={() => setShowUserGuideModal(true)}
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              minWidth: 0, // Remove MUI's default padding
            }}
          >
            <InfoOutlineIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Box>
      </Box>

      <Paper
        elevation={3}
        sx={{
          paddingBottom: 0,
          maxWidth: '100%',
          boxSizing: 'border-box',
          mx: 'auto',
          backgroundColor: theme.palette.background.paper,
          borderRadius: '16px',
        }}
      >
        <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white'
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 70, whiteSpace: 'nowrap' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 180, whiteSpace: 'nowrap' }}>Employee Code</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 180, whiteSpace: 'nowrap' }}>Sales Executive Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 120, whiteSpace: 'nowrap' }}>Designation</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 120, whiteSpace: 'nowrap' }}>Client</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem', minWidth: 120, whiteSpace: 'nowrap' }}>Candidate</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((salesExecutive, index) => (
                    <TableRow
                      key={salesExecutive.salesExecutiveId}
                      sx={{
                        backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                        '&:hover': {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                      }}
                    >
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{salesExecutive.employeeCode}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{salesExecutive.salesExecutiveName}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{salesExecutive.designation}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{salesExecutive.client}</TableCell>
                      <TableCell sx={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>{salesExecutive.candidate}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow sx={{
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}>
                    <TableCell colSpan={6} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing:7 }}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTableScrollbar>
      </Paper>

      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography variant="body2" color={theme.palette.primary.main}>
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                {rowsPerPageOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Box>
      )}

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal
        open={showUserGuideModal}
        onClose={() => setShowUserGuideModal(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 800,
            bgcolor: 'background.paper',
            borderRadius: '16px',
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box
            sx={{
              backgroundColor: theme.palette.primary.main,
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Sales Executive Performance - User Guide
            </Typography>
            <IconButton
              onClick={() => setShowUserGuideModal(false)}
              sx={{ color: '#fff', position: 'absolute', right: 14 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Scrollable Content */}
         <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
  {/* Section 1: Search Sales Executives */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
  >
    ➤ Follow these steps to search for sales executive performance records:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Use the search bar located at the top-left of the table.
    </li>
    <li>
      Enter keywords such as <strong>Sales Executive Name</strong>, <strong>Employee Code</strong>, <strong>Designation</strong>, or <strong>Client</strong> (or part of them) to filter the records.
    </li>
    <li>
      The table will automatically update to display matching performance records.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: The search is case-insensitive and filters across multiple fields for flexible searching.
  </Typography>

  {/* Section 2: Filter by Date Range */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to filter records by date range:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Use the <strong>"From Date"</strong> and <strong>"To Date"</strong> fields located next to the search bar.
    </li>
    <li>
      Select a start date in <strong>"From Date"</strong> and an end date in <strong>"To Date"</strong>.
    </li>
    <li>
      The table will automatically filter and display records that fall within the selected date range.
    </li>
    <li>
      To remove the date filter, clear both date fields.
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Dates are inclusive, and date filtering works together with search for more precise results.
  </Typography>

  {/* Section 3: View Performance Data */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Understanding the table columns:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      <strong>Employee Code:</strong> Unique identification code assigned to the sales executive.
    </li>
    <li>
      <strong>Sales Executive Name:</strong> Full name of the sales executive.
    </li>
    <li>
      <strong>Designation:</strong> Role or position held by the sales executive.
    </li>
    <li>
      <strong>Client:</strong> Client assigned to the sales executive.
    </li>
    <li>
      <strong>Candidate:</strong> Number of candidates handled (displayed as a string value).
    </li>
    <li>
      <strong>Date:</strong> Date on which the performance record was created (used for filtering but not displayed in the table).
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: This module is read-only. Adding, editing, or deleting records is not permitted.
  </Typography>

  {/* Section 4: Pagination */}
  <Typography
    variant="body1"
    sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
  >
    ➤ Follow these steps to navigate the performance list:
  </Typography>
  <ul
    style={{
      marginLeft: '20px',
      lineHeight: '1.8',
      cursor: 'pointer',
    }}
  >
    <li>
      Use the pagination controls at the bottom of the table to browse through sales executive performance records.
    </li>
    <li>
      Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
    </li>
    <li>
      Click on a specific page number to jump directly to that page.
    </li>
    <li>
      Adjust the number of rows displayed per page using the dropdown menu (for example, 5, 10, 20, or 30 rows).
    </li>
  </ul>
  <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
    ⚠️ Note: Pagination is applied after search and date filters, and only the selected number of rows per page will be shown.
  </Typography>

  {/* Bottom Close Button */}
  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
    {/* Optional close button at the bottom, if required */}
  </Box>
</CustomTableScrollbar>

        </Box>
      </Modal>
    </Container>
  );
};

export default SalesExecutivePerformance;